import { useStorage } from '@vueuse/core';

const groupMap = {
    0 : 'a', 1 : 'a', 2 : 'a', 3 : 'a',
    4 : 'b', 5 : 'b', 6 : 'b',
    7 : 'c', 8 : 'c', 9 : 'c'
};

const templateTrackingTitleMap = {
    "dropshipper-generalenquiry": "Dropshipping.General inquiry",
    "dropshipper-bestselling": "Dropshipping.Best selling products",
    "dropshipper-pricerequest": "Dropshipping.Pricing request",
    "dropshipper-productstock": "Dropshipping.Product stock",
    "dropshipper-shippercosts": "Dropshipping.Shipping costs and times",
    "dropshipper-ebayamazon": "Dropshipping.Dropshipping on eBay/Amazon",
    "wholesalers-generalinquiry": "Wholesaling/Liquidators.General inquiry",
    "wholesalers-bestproducts": "Wholesaling/Liquidators.Best selling products",
    "wholesalers-pricerequest": "Wholesaling/Liquidators.Pricing request",
    "wholesalers-productstock": "Wholesaling/Liquidators.Product stock",
    "wholesalers-shippingcosts": "Wholesaling/Liquidators.Shipping costs",
    "wholesalers-ebayamazon": "Wholesaling/Liquidators.Selling on eBay/Amazon",
    "manufacturers-leadtimes": "Manufacturers.Lead Times",
    "manufacturers-generalinquiry": "Manufacturers.General inquiry",
    "manufacturers-pricerequest": "Manufacturers.Pricing request",
    "manufacturers-productstock": "Manufacturers.Product stock",
    "manufacturers-bestproducts": "Manufacturers.Best selling products",
    "manufacturers-shippingcosts": "Manufacturers.Shipping costs",
    "manufacturers-ebayamazon": "Manufacturers.Selling on eBay/Amazon"
};

/**
 * Randomized template group by current user ID last digit
 */
export const getTemplateGroup = (userId) => {
    const group = useStorage(`inbox-template-${userId}`, null);
    if (!group.value) {
        group.value = groupMap[userId.substr(-1)] || 'a';
    }
    return group.value;
}

export const getTemplateMeta = async (variant, key) => {
    let meta = null;
    switch (variant) {
        case 'a':
            meta = (await import(/* webpackChunkName: "inbox.template" */ '@dashboardApp/data/inbox/templates/variant-a.json')).default;
            break;

        case 'b':
            meta = (await import(/* webpackChunkName: "inbox.template" */ '@dashboardApp/data/inbox/templates/variant-b.json')).default;
            break;

        case 'c':
            meta = (await import(/* webpackChunkName: "inbox.template" */ '@dashboardApp/data/inbox/templates/variant-c.json')).default;
            break;
    }

    return meta[key];
}

/**
 * Replace vars e.g. "{{ varname }}" from the meta context
 */
export const replaceMetaVars = (str, replacements = {}) => {
    for (const [variable, value] of Object.entries(replacements)) {
        str = str.replaceAll(`{{ ${variable} }}`, value);
    }
    return str;
}

export const getTemplateTrackingTitle = (key) => {
    return templateTrackingTitleMap[key] || '';
}